import ProductCard from "./ProductCard";

const RelatedWatches = ({ relatedProducts, loadingGetRelatedProducts }) => {
  if (!relatedProducts?.value || relatedProducts?.value?.length === 0) {
    return null;
  }

  return (
    <section style={{ paddingBottom: 80 }}>
      <div className="section-header">
        <div className="section-label">You May Also Like</div>
        <h2 className="section-title">Related Timepieces</h2>
        <div className="section-line" />
      </div>
      {loadingGetRelatedProducts ? (
        <div className="spinner-container">
          <div className="spinner" />
        </div>
      ) : (
        <div className="product-grid">
          {relatedProducts?.value?.map((w, i) => (
            <ProductCard key={w?.id} watch={w} index={i} />
          ))}
        </div>
      )}
    </section>
  );
};

export default RelatedWatches;
